import React from 'react';
import {
  FDBox, FDIcon, FDLabelText, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const EstatePlanningC2BHeader = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'} {...dataAttrs('ep-c2b-header')}>
      <MetaControlField attr={'title'} />
      {resource.attr('subtitle')?.map(subtitle => (
        <FDStack direction="row" paddingY={0.75} spacing={0.5}>
          <FDIcon icon="identityVerified" color="success" size="sm" />
          <FDLabelText value={subtitle} size="md" {...dataAttrs('taxbuy subtitle')} />
        </FDStack>
      ))}
      <FDStack direction={'row'} alignItems={'flex-start'} alignSelf={'flex-start'} spacing={1}>
        <MetaControlField attr={'partnerText'} />
        {resource.attr('partnerImageURL') && (
        <FDBox width={'100px'}>
          <MetaControlField attr={'partnerImageURL'} />
        </FDBox>)}
      </FDStack>
    </FDStack>
  );
};

EstatePlanningC2BHeader.defaultProps = {};

EstatePlanningC2BHeader.propTypes = {};

export { EstatePlanningC2BHeader };
